import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex flex-col space-y-4"
}
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Services ")
const _hoisted_4 = { class: "w-full grid grid-cols-12 gap-6" }
const _hoisted_5 = { class: "col-span-12 grid grid-cols-4 flex-wrap gap-6" }
const _hoisted_6 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_7 = { class: "py-3 px-3 flex flex-row items-center justify-center rounded-md bg-blue bg-opacity-10" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Service Categories ")
const _hoisted_9 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_10 = { class: "py-3 px-3 flex flex-row items-center justify-center rounded-md bg-blue bg-opacity-10" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Total Services ")
const _hoisted_12 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_13 = { class: "py-3 px-3 flex flex-row items-center justify-center rounded-md bg-green bg-opacity-10" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Trans. Volume ")
const _hoisted_15 = { class: "px-4 border-[1px] border-grey300 rounded-md py-6 col-span-1 flex flex-col space-y-2 justify-start items-center" }
const _hoisted_16 = { class: "py-3 px-3 flex flex-row items-center justify-center rounded-md bg-orange bg-opacity-10" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Most Used ")
const _hoisted_18 = { class: "mdlg:!col-span-12 col-span-full flex flex-col space-y-3 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_19 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Statistics ")
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row items-center space-x-5 justify-center\"><div class=\"flex space-x-2 items-center flex-row\"><span class=\"h-[8px] w-[8px] bg-[#FE9F5E] rounded\"></span><span>View</span></div><div class=\"flex space-x-2 items-center flex-row\"><span class=\"h-[8px] w-[8px] bg-[#409FFF] rounded\"></span><span>Usage</span></div></div><div></div>", 2)
const _hoisted_23 = { class: "w-full h-[330px]" }
const _hoisted_24 = { class: "mdlg:!col-span-6 col-span-full flex flex-col space-y-3 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_25 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Trans. Volume ")
const _hoisted_27 = { class: "w-full h-[330px]" }
const _hoisted_28 = { class: "w-full grid grid-cols-2 gap-3" }
const _hoisted_29 = { class: "col-span-1 flex flex-col items-center justify-center border-r-[1px] border-gray-100" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Minimum ")
const _hoisted_31 = { class: "col-span-1 flex flex-col items-center justify-center" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Maximum ")
const _hoisted_33 = { class: "mdlg:!col-span-6 col-span-full flex flex-col space-y-3 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_34 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Bookings by service ")
const _hoisted_36 = { class: "w-full h-[330px]" }
const _hoisted_37 = { class: "w-full grid grid-cols-2 gap-3" }
const _hoisted_38 = { class: "col-span-1 flex flex-col items-center justify-center border-r-[1px] border-gray-100" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Least booked ")
const _hoisted_40 = { class: "col-span-1 flex flex-col items-center justify-center" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Most booked ")
const _hoisted_42 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_43 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Service Categories ")
const _hoisted_45 = { class: "flex flex-row space-x-2" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Add New")
const _hoisted_47 = { class: "w-full flex flex-col py-3" }
const _hoisted_48 = { class: "col-span-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_49 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Services ")
const _hoisted_51 = { class: "flex flex-row space-x-2" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Add New")
const _hoisted_53 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_icon = _resolveComponent("roof-icon")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_bar_chart = _resolveComponent("roof-bar-chart")!
  const _component_roof_select = _resolveComponent("roof-select")!
  const _component_roof_pie_chart = _resolveComponent("roof-pie-chart")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_ctx.productOverview)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_roof_header_text, { size: "xl" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_roof_icon, {
                  name: "product-blue",
                  "custom-class": "h-[20px]"
                })
              ]),
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.productOverview.GetServiceOverview.total_service_categories), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_roof_normal_text, null, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_roof_icon, {
                  name: "product-blue",
                  "custom-class": "h-[20px]"
                })
              ]),
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.productOverview.GetServiceOverview.total_services), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_roof_normal_text, null, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_roof_icon, {
                  name: "product-green",
                  "custom-class": "h-[20px]"
                })
              ]),
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Logic.Common.convertToMoney(
                _ctx.productOverview.GetServiceOverview.transaction_volume,
                true,
                'ngn'
              )), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_roof_normal_text, null, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_roof_icon, {
                  name: "product-orange",
                  "custom-class": "h-[20px]"
                })
              ]),
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.productOverview.GetServiceOverview.most_used_service), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_roof_normal_text, null, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_roof_bar_chart, {
                data: _ctx.productStatsData,
                type: "vertical",
                "is-amount": false,
                labelArray: ['Views', 'Usage'],
                "custom-class": 'px-4 py-4',
                height: '!h-[320px]'
              }, null, 8, ["data"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createVNode(_component_roof_select, {
                  placeholder: `${_ctx.Logic.Common.momentInstance(
                _ctx.serviceTransdates.from
              ).format('Do MMM YYYY')} - ${_ctx.Logic.Common.momentInstance(
                _ctx.serviceTransdates.to
              ).format('Do MMM YYYY')}`,
                  "custom-class": 'w-[300px] cursor-pointer',
                  paddings: "py-2 px-3",
                  isDatePicker: true,
                  dateDefault: _ctx.serviceTransdates,
                  modelValue: _ctx.serviceTransData,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serviceTransData) = $event)),
                  dateDifference: 0
                }, null, 8, ["placeholder", "dateDefault", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.ServiceCategoryTransactions)
                ? (_openBlock(), _createBlock(_component_roof_pie_chart, {
                    key: 0,
                    "size-ratio": 3.8,
                    data: _ctx.ServiceCategoryTransactions
                  }, null, 8, ["size-ratio", "data"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_roof_header_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Logic.Common.convertToMoney(_ctx.transactionStats.min, true, 'ngn')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_roof_normal_text, { "custom-class": "opacity-[0.7]" }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_roof_header_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Logic.Common.convertToMoney(_ctx.transactionStats.max, true, 'ngn')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_roof_normal_text, { "custom-class": "opacity-[0.7]" }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createVNode(_component_roof_select, {
                  placeholder: `${_ctx.Logic.Common.momentInstance(
                _ctx.serviceBookingdates.from
              ).format('Do MMM YYYY')} - ${_ctx.Logic.Common.momentInstance(
                _ctx.serviceBookingdates.to
              ).format('Do MMM YYYY')}`,
                  "custom-class": 'w-[300px] cursor-pointer',
                  paddings: "py-2 px-3",
                  isDatePicker: true,
                  dateDefault: _ctx.serviceBookingdates,
                  modelValue: _ctx.serviceBookingData,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.serviceBookingData) = $event)),
                  dateDifference: 0
                }, null, 8, ["placeholder", "dateDefault", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              (_ctx.ServiceCategoryBookings)
                ? (_openBlock(), _createBlock(_component_roof_pie_chart, {
                    key: 0,
                    "size-ratio": 3.8,
                    data: _ctx.ServiceCategoryBookings,
                    "is-money": false
                  }, null, 8, ["size-ratio", "data"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_roof_header_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.bookingStatData.least), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_roof_normal_text, { "custom-class": "opacity-[0.7]" }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_roof_header_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.bookingStatData.most), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_roof_normal_text, { "custom-class": "opacity-[0.7]" }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_roof_button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddServiceCategory()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_roof_table, {
                ref: "categoryTableRef",
                tableStructure: _ctx.Logic.Product.ServiceCategoriesTableStructure,
                paginatedData: _ctx.productOverview.GetServiceCategories,
                "table-date-source": _ctx.Logic.Product.ServiceCategorySource,
                "sub-page-route": '/services/category/'
              }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_roof_header_text, { size: "lg" }, {
                default: _withCtx(() => [
                  _hoisted_50
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_roof_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddService()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_52
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_roof_table, {
                ref: "serviceTableRef",
                tableStructure: _ctx.Logic.Product.ServiceTableStructure,
                paginatedData: _ctx.productOverview.GetServices,
                "table-date-source": _ctx.Logic.Product.ServiceSource,
                "sub-page-route": '/services/'
              }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}